/**
 * Woocommerce related Javascript
 */

import $ from "jquery";

import Cart from "./woocommerce/cart";
import Checkout from "./woocommerce/checkout";
import Account from "./woocommerce/account";
import Product from "./woocommerce/product";
import Wishlist from "./woocommerce/wishlist";
import ProductFilesModal from "./woocommerce/productfilesmodal";
import Loginmodal from "./woocommerce/loginmodal";

// search-form
class Woocommerce {
	constructor() {
		if ($(".single-product").length) {
			new Product();
		}
		if ($(".archive").length) {
			new Product();
		}
		if ($(".woocommerce").length) {
			new Cart();
			new Wishlist();
			new Account();
			new Checkout();
			new ProductFilesModal();
			new Loginmodal();
		}
	}
}

export default Woocommerce;
